import React from "react";

import { NavigationButton, NavigationButtonProps } from "ui";

import { useStackedNavigationContext } from "./StackedNavigationContext";

const StackedNavigationButton: React.FC<NavigationButtonProps> = ({ onClick, disabled, target, ...props }) => {
  const { open } = useStackedNavigationContext();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (disabled) return;
    if (typeof target !== "undefined") {
      open(target);
      return;
    }
    onClick?.(event);
  };

  return <NavigationButton onClick={handleClick} disabled={disabled} {...props} />;
};

export default StackedNavigationButton;
